module.exports = __webpack_public_path__ + "img/seminario_digico2014.b727e5db.jpg";